<template>
	<layout-admin-auto-loading class="admin-watch-list" :loader="getWatches" :loading="loading" :finished="finished" :error="error">
		<div slot="header" class="slot">
			<h1>(Admin) Watch List</h1>
			<button-icon-text :to="{ name: 'AdminWatchAdd' }" icon="plus-w" class="plus btn-add">Add Watch</button-icon-text>
		</div>
		<div slot="body" v-if="!error">
			<div v-if="data.length" class="idi-table watches">
				<div class="idi-header">
					<div class="idi-cell">ID</div>
					<div class="idi-cell">IMEI</div>
					<div class="idi-cell"></div>
				</div>
				<div class="idi-row" v-for="watch in data" :key="watch.id">
					<div class="idi-cell grid-area-id">
						<span>{{ watch.id }}</span>
					</div>
					<div class="idi-cell grid-area-imei">
						<span>{{ watch.uid }}</span>
					</div>
					<div class="idi-cell grid-area-operations">
						<button-icon :to="{ name: 'AdminWatchEdit', params: { watch_id: watch.id, data: watch } }" icon="edit" title="Edit"/>
					</div>
				</div>
			</div>
			<p v-if="finished && !data.length">No watches found.</p>
		</div>
	</layout-admin-auto-loading>
</template>

<script>
import LayoutAdminAutoLoading from '../LayoutAdminAutoLoading'
export default {
	components: {
		LayoutAdminAutoLoading
	},
	data () {
		return {
			loading: false,
			error: null,
			data: [],
			finished: false,
			limit: 20
		}
	},
	computed: {
		offset () {
			return this.data.length
		}
	},
	methods: {
		getWatches () {
			this.loading = true
			this.$api.watches.admin.getAll(this, this.offset, this.limit).then(response => {
				this.$log.info('admin', 'watches.admin.getAll OK', response)()
				if (response.body.length) {
					this.data = this.data.concat(response.body)
				}
				if (!response.body.length || response.body.length < this.limit) {
					this.finished = true
				}
			}).catch(errors => {
				this.$log.error('admin', 'watches.admin.getAll ERROR', errors)()
				this.error = errors
			}).finally(() => {
				this.loading = false
			})
		}
	},
	beforeCreate () {
		this.$title('Watch List')
	}
}
</script>



// WEBPACK FOOTER //
// src/components/admin/watches/WatchList.vue